<script lang="ts">
	import VerivoxOffersBanner from './internal/VerivoxOffersBanner.svelte';
	import type { VerivoxDismissSurface } from '../utils/verivoxDismissals';

	/** Verivox offers promo for GlobalInlineBanners rail (~120px). */
	export let dismissable = false;
	export let dismissSurface: VerivoxDismissSurface = 'roomsList';
	export let onDismiss: (() => void) | undefined;
</script>

<VerivoxOffersBanner
	layout="inline"
	{dismissable}
	{dismissSurface}
	{onDismiss}
/>
